/** App-wide toasts (OutlierOS lib/toast): success / error / info, optional description and action. */
export type ToastKind = 'success' | 'error' | 'info';
export interface ToastAction { label: string; href?: string; onClick?: () => void }
export interface ToastItem { id: number; kind: ToastKind; message: string; description?: string; action?: ToastAction; durationMs: number }

type Listener = (items: ToastItem[]) => void;
let items: ToastItem[] = [];
let next = 1;
const listeners = new Set<Listener>();
const emit = () => listeners.forEach((l) => l(items));

export function subscribeToasts(l: Listener): () => void {
  listeners.add(l);
  l(items);
  return () => void listeners.delete(l);
}

export function dismissToast(id: number) {
  items = items.filter((t) => t.id !== id);
  emit();
}

function push(kind: ToastKind, message: string, opts: { description?: string; action?: ToastAction; durationMs?: number } = {}) {
  const t: ToastItem = { id: next++, kind, message, description: opts.description, action: opts.action, durationMs: opts.durationMs ?? (kind === 'error' ? 7000 : 4000) };
  items = [...items, t].slice(-4); // at most 4 on screen
  emit();
  setTimeout(() => dismissToast(t.id), t.durationMs);
  return t.id;
}

export const toast = {
  success: (m: string, o?: Parameters<typeof push>[2]) => push('success', m, o),
  error: (m: string, o?: Parameters<typeof push>[2]) => push('error', m, o),
  info: (m: string, o?: Parameters<typeof push>[2]) => push('info', m, o),
};
